import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone'; // dependent on utc plugin
import utc from 'dayjs/plugin/utc';

try {
  dayjs.extend(customParseFormat);
  dayjs.extend(localizedFormat);
  dayjs.extend(utc);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(timezone);
} catch (e) {
  Sentry.setExtra('message', 'dayjs.extend');
  Sentry.captureException(e);
}

const locales = {
  pl: () => import('dayjs/locale/pl'),
  en: () => import('dayjs/locale/en'),
  ru: () => import('dayjs/locale/ru'),
  fr: () => import('dayjs/locale/fr'),
  tr: () => import('dayjs/locale/tr'),
};

export function updateLocale(locale: 'en' | 'pl' | 'ru' | 'fr' | 'tr') {
  locales[locale]().then(() => {
    dayjs.locale(locale);
  });
}
